/* tslint:disable */
/* eslint-disable */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IGroup } from '../models';
// @ts-ignore
import type { ILoginRequest } from '../models';
// @ts-ignore
import type { ILoginResponse } from '../models';
// @ts-ignore
import type { IRegisterRequest } from '../models';
// @ts-ignore
import type { IUser } from '../models';
/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptPassword: async (password: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'password' is not null or undefined
            assertParamExists('encryptPassword', 'password', password)
            const localVarPath = `/api/auth/encryptPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/getAllUsersWithGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paintShopId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsForShop: async (paintShopId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paintShopId' is not null or undefined
            assertParamExists('getGroupsForShop', 'paintShopId', paintShopId)
            const localVarPath = `/api/auth/getGroupsForShop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paintShopId !== undefined) {
                localVarQueryParameter['paintShopId'] = paintShopId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPassword: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPassword', 'userId', userId)
            const localVarPath = `/api/auth/getPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getUserData', 'token', token)
            const localVarPath = `/api/auth/getUserData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ILoginRequest} iLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (iLoginRequest: ILoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iLoginRequest' is not null or undefined
            assertParamExists('login', 'iLoginRequest', iLoginRequest)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IRegisterRequest} iRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (iRegisterRequest: IRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iRegisterRequest' is not null or undefined
            assertParamExists('register', 'iRegisterRequest', iRegisterRequest)
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUserPasswordReset: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('requestUserPasswordReset', 'email', email)
            const localVarPath = `/api/auth/requestUserPasswordReset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguage: async (userId: string, language: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateLanguage', 'userId', userId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('updateLanguage', 'language', language)
            const localVarPath = `/api/auth/updateLanguage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} printerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDefaultPrinter: async (userId: string, printerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserDefaultPrinter', 'userId', userId)
            // verify required parameter 'printerId' is not null or undefined
            assertParamExists('updateUserDefaultPrinter', 'printerId', printerId)
            const localVarPath = `/api/auth/updateUserDefaultPrinter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (printerId !== undefined) {
                localVarQueryParameter['printerId'] = printerId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async encryptPassword(password: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.encryptPassword(password, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.encryptPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersWithGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersWithGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getAllUsersWithGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paintShopId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupsForShop(paintShopId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupsForShop(paintShopId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getGroupsForShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPassword(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPassword(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserData(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserData(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getUserData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ILoginRequest} iLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(iLoginRequest: ILoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(iLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IRegisterRequest} iRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(iRegisterRequest: IRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(iRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestUserPasswordReset(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestUserPasswordReset(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.requestUserPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLanguage(userId: string, language: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLanguage(userId, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.updateLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} printerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDefaultPrinter(userId: string, printerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDefaultPrinter(userId, printerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.updateUserDefaultPrinter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptPassword(password: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.encryptPassword(password, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<IUser>> {
            return localVarFp.getAllUsersWithGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paintShopId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsForShop(paintShopId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IGroup>> {
            return localVarFp.getGroupsForShop(paintShopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPassword(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPassword(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(token: string, options?: RawAxiosRequestConfig): AxiosPromise<IUser> {
            return localVarFp.getUserData(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ILoginRequest} iLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(iLoginRequest: ILoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ILoginResponse> {
            return localVarFp.login(iLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IRegisterRequest} iRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(iRegisterRequest: IRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ILoginResponse> {
            return localVarFp.register(iRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUserPasswordReset(email: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.requestUserPasswordReset(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguage(userId: string, language: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLanguage(userId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} printerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDefaultPrinter(userId: string, printerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserDefaultPrinter(userId, printerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 */
export interface AuthApiInterface {
    /**
     * 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    encryptPassword(password: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllUsersWithGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<IUser>>;

    /**
     * 
     * @param {string} paintShopId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupsForShop(paintShopId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IGroup>>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPassword(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserData(token: string, options?: RawAxiosRequestConfig): AxiosPromise<IUser>;

    /**
     * 
     * @param {ILoginRequest} iLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(iLoginRequest: ILoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ILoginResponse>;

    /**
     * 
     * @param {IRegisterRequest} iRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(iRegisterRequest: IRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ILoginResponse>;

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestUserPasswordReset(email: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @param {string} userId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLanguage(userId: string, language: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {number} printerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserDefaultPrinter(userId: string, printerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public encryptPassword(password: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).encryptPassword(password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllUsersWithGroups(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getAllUsersWithGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paintShopId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGroupsForShop(paintShopId: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getGroupsForShop(paintShopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPassword(userId: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getPassword(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserData(token: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getUserData(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ILoginRequest} iLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(iLoginRequest: ILoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(iLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IRegisterRequest} iRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public register(iRegisterRequest: IRegisterRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).register(iRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestUserPasswordReset(email: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).requestUserPasswordReset(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLanguage(userId: string, language: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).updateLanguage(userId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {number} printerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserDefaultPrinter(userId: string, printerId: number, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).updateUserDefaultPrinter(userId, printerId, options).then((request) => request(this.axios, this.basePath));
    }
}

